import { getPathReduxUtil } from '../../../redux/utils/get-path'
import { REFERENCES_DOMAIN } from '../../constants'
import getReferencesSelector from '../../selectors/get'
import setUtil from '../../../../utils/set'

function addReferenceUtil (params) {
  const {
    state,
    instance,
    referencePath
  } = params
  const path = getPathReduxUtil(instance)
  // logUtil('addReferenceUtil')
  //   .debug(`path ${path}, referencePath ${referencePath}`)
  const references = getReferencesSelector(path)(state)
  if (references.includes(referencePath)) {
    return
  }
  // Add the new `referencePath`
  let newReferences = [
    ...references,
    referencePath
  ]
  // If the `referencePath` is already present but using the `changed` or
  // `data` instance key, remove it e.g. `newReferences =
  // ['plans.data.41.changed.workouts', 'plans.data.41.data.workouts'] the
  // first element should be removed
  const referencePathArr = referencePath.split('.')
  const dataKey = referencePathArr[3]
  const oppositeDataKey = dataKey === 'changed'
    ? 'data'
    : 'changed'
  const referencePathOppositeDataKey = [
    ...referencePathArr.slice(0, 3),
    oppositeDataKey,
    ...referencePathArr.slice(4)
  ].join('.')
  if (newReferences.includes(referencePathOppositeDataKey)) {
    newReferences = newReferences.filter(newRef => newRef !==
      referencePathOppositeDataKey)
  }
  // logUtil('addReferenceUtil')
  //   .debug(`newReferences `, newReferences)
  // Add the new references
  const referencesPath = `${REFERENCES_DOMAIN}.${path}`

  return {
    state: setUtil(state, referencesPath, newReferences, { step: 1 }),
    referencesPath,
    newReferences
  }
}

export default addReferenceUtil
